const SYSTEM_RESTART_TIME = '05:31';

//SUPORTE
const SUPPORT_EMAIL = 'contato@easy360.ind.br';
const URL_CT360 = 'https://cursos.hk360.com.br/formacao-planner/';
const URL_FALE_CONOSCO = 'https://www.easy360.ind.br/contato';

export { SUPPORT_EMAIL, SYSTEM_RESTART_TIME, URL_CT360, URL_FALE_CONOSCO };
